import { ChartBot } from "./ChartBot";
import { useBot } from "../../context/botContext";
import { useBotDemo } from "../../context/botDemoContext";
import BotOverviewXenoArc from "./BotOverviewXenoArc";
import BotOverviewRebalance from "./create-bot-setting/RebalanceComponent";
import BotOverviewDCA from "../botlist/BotOverviewDCA";
// import BotOverviewDCA from "./create-bot-setting/DCAComponent";

export const ChartAndListBotActive = () => {
  const {
    strategyLists,
    loadingBotLists,
    botDetail,
    botLists,
    selectedBot,
    setSelectedBot,
    loadingBotDetail,
    setSelectedStrategy,
    setOpenDialogBot,
  } = useBotDemo();

  const handleBotClick = (bot) => {
    setSelectedBot(bot);
  };

  const RenderBotOverview = () => {
    const strategy = selectedBot?.bot_strategy?.toLowerCase();

    if (["xenoarc", "xeno arc", "xeno bot v3", "grid"].includes(strategy)) {
      return (
        <BotOverviewXenoArc
          selectedBot={botDetail}
          loading={loadingBotDetail}
          setOpenDialog={setOpenDialogBot}
        />
      );
    }

    switch (strategy) {
      case "rebalance":
        return (
          <BotOverviewRebalance
            selectedBot={botDetail}
            loading={loadingBotDetail}
            setOpenDialog={setOpenDialogBot}
          />
        );
      case "dca":
        return (
          <BotOverviewDCA
            selectedBot={botDetail}
            loading={loadingBotDetail}
            setOpenDialog={setOpenDialogBot}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className=" w-full flex flex-col gap-4">
      {!!botLists.length ? (
        <>
          <div className="h-[35vh] lg:h-[60vh] bg-white rounded-xl md:py-4 md:pr-4 md:pl-3">
            <ChartBot />
          </div>
          {RenderBotOverview()}
        </>
      ) : (
        // NO BOT ACTIVE
        <div className="w-full h-[35vh] lg:h-[85vh] flex flex-col justify-center items-center bg-white rounded-xl">
          <img
            src={"/images/icons/icon_no_bot_activated.svg"}
            alt=""
            className="w-[140px] h-[140px] lg:w-[200px] lg:h-[200px]"
          />
          <p className="text-[#697077] text-base text-center w-[80%] lg:w-full">
            Not activated yet? Start your bot and begin trading instantly.
          </p>
        </div>
      )}
    </div>
  );
};
